import { PlayerApi } from '../../../api/player/player_api';
import { sendToIframe } from 'utilities/communication';
import { MESSAGES } from 'constants/communication';
import { getCurrentScriptSource, findEmbed } from 'utilities/dom';
import { querystring } from 'utilities/context';

// proxies player control events to iframe
export class IFrameApiProxy extends PlayerApi {
    constructor(iframeEl) {
        super();
        this.iframeEl = iframeEl;
    }

    get eventBus() {
        const target = this.iframeEl;

        return {
            emit: (event, ...args) => {
                this.broadcast({ event, args, target: target, id: this.id })
            }
        }
    }

    set eventBus(bus) {
        super.eventBus = bus;
    }

    broadcast(message) {
        const { id, target } = message;
        sendToIframe(target && target.contentWindow, { id: id, ...message });
    }
}